/**
 * 生产环境配置文件
 * 如果程序开发过程中需要增加参数，请同步更新该文件
 */
// 智盈php接口域名
export const API_HOST = 'https://gf.guotaijiu.com/'
export const API_HOST_JAVA = 'https://gf.guotaijiu.com/v2/'
// 智盈java版接口域名
export const API_HOST_JAVA_SET = 'https://gf.guotaijiu.com/v2/'
export const API_IMG_HOST = 'https://gf.guotaijiu.com/'
export const CDN_IMG_HOST = 'https://member.intelliquor.com/'
export const YZ_HOST = 'https://center.intelliquor.com/'
export const YZ_HOST_API = 'https://yz.intelliquor.com/'
export const YT_HOST_API = 'https://yt.baijiuyun.com/'
// 大后台接口域名
export const DHT_HOST_API = 'https://gf.guotaijiu.com/manage'
// 布奖前端
export const FRONTEND_MARKET_URL = '//szhqd.guotaijiu.com/market/'
// 会员中心前端
export const FRONTEND_MEMBER_URL = '//szhqd.guotaijiu.com/member/'
// 云店
export const YD_HOST_API = '//szhqd.guotaijiu.com/cloudshop/goods/goods'
// 云商
export const YS_HOST_API = '//szhqd.guotaijiu.com/clouddealer/'
// 云销
export const YX_HOST_API = '//szhqd.guotaijiu.com/cloudsalesman/'
// 品鉴酒
export const FRONTEND_WINE_URL = '//szhqd.guotaijiu.com/savourwine/'
// 饮酒顾问
export const YINJIU_GUWEN = '//szhqd.guotaijiu.com/drinkadvisory/'
// 领袖会
export const LX_HY_URL = '//szhqd.guotaijiu.com/clouddealer/'
// 饮酒联盟
export const YJ_LM_URL = '//szhqd.guotaijiu.com/cloudshop/goods/goods'
// 终端管理
export const ZD_GL_URL = '//szhqd.guotaijiu.com/terminal'
// 业代任务发布
export const YD_RW_URL = '//task.zd.guotaijiu.com/terminal'
// 国粉俱乐部
export const GUOFEN_CLUB_URL = '//szhqd.guotaijiu.com/drinkclub/'
// 国台封坛
export const GUOTAI_FENGTAN = '//szhqd.guotaijiu.com/guotaisealaltar/'

// 应用服务菜单区分正式环境，测试环境
export const ENVCONFIG = 'prod'

export const IMAGE_LOGIN_LEFT = 'static/img/guotai/loginLeft.gif'
export const IMAGE_LOGIN_LOGO = 'static/img/guotai/logo.png'
export const LOGIN_TITLE = '国台数字营销平台管理后台'